import React, { useEffect } from 'react';
import { isPickedHorse, useGetPickedHorse, useUpsertEntry } from '../../store/entry/entryActions';
import { useShowUpdatedText } from '../../hooks/showUpdatedText/showUpdatedText';
import { getCards } from './EntryPicksWrapper.functions';
import { useGetHorseInfo } from '../HorseCard/HorseCard.functions';

interface EntryPicksWrapperProps {
  onClick?: (eventNumber: number) => void;
  updateEventNumber?: number;
  state: 'pre-play' | 'in-play';
  uniqueId: string;
}

const EntryPicksWrapper = ({ onClick, updateEventNumber, state, uniqueId }: EntryPicksWrapperProps) => {
  const pickedHorses = useGetPickedHorse();
  const updatedHorse = pickedHorses.filter(isPickedHorse).find((horse) => horse.eventNumber === updateEventNumber);
  const showUpdated = useShowUpdatedText(
    updatedHorse ? `${updatedHorse?.selectionCode}|${updatedHorse?.eventNumber}` : undefined,
  );
  const upsertFunc = useUpsertEntry({ uniqueId });
  const getHorseInfo = useGetHorseInfo();

  //this is a stable function, so it can be called on each rerender. internally if the page renders and nothing has changed it will not call the API
  //may need a useEffect here
  useEffect(() => {
    upsertFunc();
  }, [upsertFunc]);

  const cards = getCards({
    state,
    onClick,
    updateEventNumber,
    showUpdated,
    pickedHorses,
    getHorseInfo,
  });

  return <div className={'entry-picks-wrapper'}>{cards}</div>;
};
export default EntryPicksWrapper;
